(function () {

  const FORM_ROOT_SELECTOR = '[data-forms-id="forms-root-826132"]';
  const POPUP_STORAGE_KEY = 'wishlist_popup_opened';
  const FORM_SUBMITTED_KEY = 'wishlist_form_submitted';

  let formNode = null;
  let originalParent = null;
  let isOpenedPopup = false;

  /* -----------------------------
     Wait for Shopify Form to load
  ----------------------------- */
  function waitForForm(callback) {
    if (formNode) {
      callback();
      return;
    }

    const observer = new MutationObserver(function () {
      const form = document.querySelector(FORM_ROOT_SELECTOR);
      if (!form) return;

      formNode = form;
      originalParent = form.parentNode;
      observer.disconnect();

      callback();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  /* -----------------------------
     Popup handlers
  ----------------------------- */
  function openWishlistPopup() {
    if (localStorage.getItem(FORM_SUBMITTED_KEY) === 'true') return; // don't open if submitted

    const popup = document.getElementById("wishlist-popup");
    const slot = document.getElementById("popup-form-slot");
    if (!popup || !slot) return;

    waitForForm(function () {

      function observeShopifyFormEmbed() {
        const embed = popup.querySelector('shopify-forms-embed#app-embed');
        if (!embed) return setTimeout(observeShopifyFormEmbed, 50);
        const checkShadow = () => {
          const shadow = embed.shadowRoot;
          if (!shadow) return setTimeout(checkShadow, 50);
          const form = shadow.querySelector('form');
          if (!form) return setTimeout(checkShadow, 50);
          form.addEventListener('submit', (e) => {
            localStorage.setItem(FORM_SUBMITTED_KEY, 'true');
          });
          function styleShopifyForm(form) {
            const shadow = form.getRootNode(); // shadowRoot
            const style = document.createElement('style');
            style.textContent = `
              label#label-phone_number {
                  top: 1em !important;
              }
              #app-embed section {
                min-height: auto;
              }
               #app-embed ._gridItemContent_1q1d2_257 {
                  padding-bottom: 10px;
              }
            `;
            shadow.appendChild(style);
          }

          // Call the styling function
          styleShopifyForm(form);
        };

        checkShadow();
      }

      // Start the observer
      observeShopifyFormEmbed();

      slot.appendChild(formNode);
      popup.classList.add("active");
    });
    localStorage.setItem(POPUP_STORAGE_KEY, 'true');
    isOpenedPopup = true;
  }

  window.closeWishlistPopup = function () {
    const popup = document.getElementById("wishlist-popup");
    if (!popup || !formNode || !originalParent) return;

    originalParent.appendChild(formNode);
    popup.classList.remove("active");
    localStorage.removeItem(POPUP_STORAGE_KEY);
    isOpenedPopup = false;
  };

  /* -----------------------------
     Wishlist click detection
  ----------------------------- */
  document.addEventListener("click", function (e) {
    if (localStorage.getItem(FORM_SUBMITTED_KEY) === 'true') return;

    const button = e.target.closest("button.wk-button");
    if (!button) return;
    if (!button.closest("wishlist-button-collection")) return;
    if (button.classList.contains("wk-selected")) return;

    setTimeout(function () {
      if (button.classList.contains("wk-selected")) {
        openWishlistPopup();
      }
    }, 200);
  }, true);

})();
